"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Map = _interopRequireDefault(require("./Map.js"));

var _ObjectEventType = _interopRequireDefault(require("../ObjectEventType.js"));

var _Event = _interopRequireDefault(require("../render/Event.js"));

var _EventType = _interopRequireDefault(require("../render/EventType.js"));

var _State = _interopRequireDefault(require("../source/State.js"));

var _css = require("../css.js");

var _canvas = require("../render/canvas.js");

var _Layer = require("../layer/Layer.js");

var _events = require("../events.js");

var _dom = require("../dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/renderer/Composite
 */


/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */
var CompositeMapRenderer =
/** @class */
function (_super) {
  __extends(CompositeMapRenderer, _super);
  /**
   * @param {import("../PluggableMap.js").default} map Map.
   */


  function CompositeMapRenderer(map) {
    var _this = _super.call(this, map) || this;
    /**
     * @type {import("../events.js").EventsKey}
     */


    _this.fontChangeListenerKey_ = (0, _events.listen)(_canvas.checkedFonts, _ObjectEventType["default"].PROPERTYCHANGE, map.redrawText.bind(map));
    /**
     * @private
     * @type {HTMLDivElement}
     */

    _this.element_ = document.createElement('div');
    var style = _this.element_.style;
    style.position = 'absolute';
    style.width = '100%';
    style.height = '100%';
    style.zIndex = '0';
    _this.element_.className = _css.CLASS_UNSELECTABLE + ' ol-layers';
    var container = map.getViewport();
    container.insertBefore(_this.element_, container.firstChild || null);
    /**
     * @private
     * @type {Array<HTMLElement>}
     */

    _this.children_ = [];
    /**
     * @private
     * @type {boolean}
     */

    _this.renderedVisible_ = true;
    return _this;
  }
  /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   */


  CompositeMapRenderer.prototype.dispatchRenderEvent = function (type, frameState) {
    var map = this.getMap();

    if (map.hasListener(type)) {
      var event_1 = new _Event["default"](type, undefined, frameState);
      map.dispatchEvent(event_1);
    }
  };

  CompositeMapRenderer.prototype.disposeInternal = function () {
    (0, _events.unlistenByKey)(this.fontChangeListenerKey_);
    this.element_.parentNode.removeChild(this.element_);

    _super.prototype.disposeInternal.call(this);
  };
  /**
   * Render.
   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
   */


  CompositeMapRenderer.prototype.renderFrame = function (frameState) {
    if (!frameState) {
      if (this.renderedVisible_) {
        this.element_.style.display = 'none';
        this.renderedVisible_ = false;
      }

      return;
    }

    this.calculateMatrices2D(frameState);
    this.dispatchRenderEvent(_EventType["default"].PRECOMPOSE, frameState);
    var layerStatesArray = frameState.layerStatesArray.sort(function (a, b) {
      return a.zIndex - b.zIndex;
    });
    var viewState = frameState.viewState;
    this.children_.length = 0;
    /**
     * @type {Array<import("../layer/BaseVector.js").default>}
     */

    var declutterLayers = [];
    var previousElement = null;

    for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
      var layerState = layerStatesArray[i];
      frameState.layerIndex = i;
      var layer = layerState.layer;
      var sourceState = layer.getSourceState();

      if (!(0, _Layer.inView)(layerState, viewState) || sourceState != _State["default"].READY && sourceState != _State["default"].UNDEFINED) {
        layer.unrender();
        continue;
      }

      var element = layer.render(frameState, previousElement);

      if (!element) {
        continue;
      }

      if (element !== previousElement) {
        this.children_.push(element);
        previousElement = element;
      }

      if ('getDeclutter' in layer) {
        declutterLayers.push(
        /** @type {import("../layer/BaseVector.js").default} */
        layer);
      }
    }

    for (var i = declutterLayers.length - 1; i >= 0; --i) {
      declutterLayers[i].renderDeclutter(frameState);
    }

    (0, _dom.replaceChildren)(this.element_, this.children_);
    this.dispatchRenderEvent(_EventType["default"].POSTCOMPOSE, frameState);

    if (!this.renderedVisible_) {
      this.element_.style.display = '';
      this.renderedVisible_ = true;
    }

    this.scheduleExpireIconCache(frameState);
  };
  /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>, (Uint8ClampedArray|Uint8Array)): T} callback Layer
   *     callback.
   * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @return {T|undefined} Callback result.
   * @template T
   */


  CompositeMapRenderer.prototype.forEachLayerAtPixel = function (pixel, frameState, hitTolerance, callback, layerFilter) {
    var viewState = frameState.viewState;
    var layerStates = frameState.layerStatesArray;
    var numLayers = layerStates.length;

    for (var i = numLayers - 1; i >= 0; --i) {
      var layerState = layerStates[i];
      var layer = layerState.layer;

      if (layer.hasRenderer() && (0, _Layer.inView)(layerState, viewState) && layerFilter(layer)) {
        var layerRenderer = layer.getRenderer();
        var data = layerRenderer.getDataAtPixel(pixel, frameState, hitTolerance);

        if (data) {
          var result = callback(layer, data);

          if (result) {
            return result;
          }
        }
      }
    }

    return undefined;
  };

  return CompositeMapRenderer;
}(_Map["default"]);

var _default = CompositeMapRenderer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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